// Utility functions for managing accordion blocks

// Generate a simple unique id for accordion items
function generateId() {
  return 'acc-' + Math.random().toString(36).substr(2, 9);
}

export function createAccordionModal(initialItems = []) {
  const items = initialItems.length ? initialItems : [{
    id: generateId(),
    title: '',
    content: '',
    isOpen: false
  }];
  return { items };
}

export function addAccordionItem(items) {
  if (items.length >= 10) return items;
  return [...items, { id: generateId(), title: '', content: '', isOpen: false }];
}

export function removeAccordionItem(items, id) {
  return items.filter(item => item.id !== id);
}

export function updateAccordionItem(items, id, data) {
  return items.map(item => (item.id === id ? { ...item, ...data } : item));
}

export function reorderAccordionItems(items, newOrder) {
  return newOrder;
}

export function generateAccordionHTML(items) {
  return `<div class="accordion-container">${items
    .map(
      item => `\n  <details class="accordion-item">\n    <summary class="accordion-header">\n      <h3 class="accordion-title">${item.title}</h3>\n      <div class="chevron" aria-hidden="true"></div>\n    </summary>\n    <div class="accordion-content">${item.content}</div>\n  </details>`
    )
    .join('\n')}\n</div>`;
}

export function saveAccordionBlock(block, items, settings = {}) {
  return { ...block, type: 'accordion', items, settings };
}
